import { Component, OnInit, Injector, ComponentFactoryResolver, ViewChild, TemplateRef, Optional, ChangeDetectorRef, Inject, LOCALE_ID } from '@angular/core';
import { BsModalService } from '@farris/ui-modal';
import { ProcessDesignerUIState } from '../../../app/process-designer.uistate';
import { HttpService, SessionService } from '@ecp-caf/caf-common';
import { RtfAppHelpComponent } from '@gsp-sys/rtf-ui';
import { RtfApp } from '@gsp-sys/rtf-ui/lib/rtf-app-help/entities/rtf-app';
import { of, Observable, Subject, from, forkJoin } from 'rxjs';
import { PickedResult, ServerSideToken, LookupGridComponent } from '@farris/ui-lookup';
import { FormFormatService } from './form-format.service';
import { ExecuteFormModel, TerminalType, ActualParameter } from '../entities/execute-form.entity';
import { DatagridComponent } from '@farris/ui-datagrid';
import { MessagerService } from '@farris/ui-messager';
import { ExecuteForm } from '../entities/execute-form';
import { ProcessDeUtil } from '../../../domain/process-de-util';
import { map } from 'rxjs/operators';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../../i18n/assets/lang.resource';

@Component({
  selector: 'lib-add-execute-form',
  templateUrl: './add-execute-form.component.html',
  styleUrls: ['./add-execute-form.component.scss'],
  providers: [{
    provide: ServerSideToken, useClass: FormFormatService },
     WfLocalePipe
  ]
})
export class AddExecuteFormComponent implements OnInit {

  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  // @ViewChild(RtfAppHelpComponent) public appHelper: RtfAppHelpComponent;
  // @ViewChild('lookup') public lookUp: LookupGridComponent;
  @ViewChild('grid') private grid: DatagridComponent;

  submit = new Subject<ExecuteFormModel>();
  cancel = new Subject();

  tab: 'web' | 'mobile';

  oldFormFormatId;

  oldComponentId;

  forms = new Array<ExecuteForm>();

  // private formTypeCollection = [
  //   { text: '流程嵌表单', value: '0' },
  //   { text: '表单嵌流程', value: '1' },
  // ];

  columns = [
    { field: 'code', width: 100, title: this.localePipe.transform('component.executeForms.code') },
    {
      field: 'name', width: 100, title: this.localePipe.transform('component.executeForms.name'),
    },
    {
      field: 'tag', width: 80, title: this.localePipe.transform('component.executeForms.apptag'),
      formatter: (v, d, i) => {
        if (d.appId) {
          return this.localePipe.transform('component.executeForms.functionMenu');
        } else if (d.formFormatId) {
          return this.localePipe.transform('component.executeForms.formFormat');
        }
      }
    }
    // {
    //   field: 'formType', width: 80, title: '联查类型',
    //   formatter: {
    //     type: 'enum',
    //     options: { valueField: 'value', textField: 'text', data: this.formTypeCollection }
    //   },
    // },
  ];

  // 表单格式显示列
  cols = [
    {
      field: 'code', width: 100, title: this.localePipe.transform('component.executeForms.docFormatNumber'), searchField: 'code'
    }, {
      field: 'name', width: 100, title: this.localePipe.transform('component.executeForms.docFormatName'), searchField: 'name'
    }
  ];

  dataUri = '/api/runtime/wf/v1.0/formFormat/page';
  constructor(
    private state: ProcessDesignerUIState,
    private http: HttpService,
    private session: SessionService,
    private message: MessagerService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
    this.getAllExecuteForms();
  }

  clickOK() {
    if (this.grid.selectedRow) {
      const form: ExecuteForm = this.grid.selectedRow.data;
      if((this.oldComponentId && this.oldComponentId === form.appId) || (this.oldFormFormatId && this.oldFormFormatId === form.formFormatId)) {
        this.message.info(this.localePipe.transform('component.executeForms.alreadySelect'));
        return;
      }
      const model = new ExecuteFormModel();
      model.Id = ProcessDeUtil.GenerateElementId();
      model.Name = form.name;
      model.ComponentId = form.appId;
      model.FormType = form.formType;
      model.formFormatId = form.formFormatId;
      model.TerminalType = this.tab === 'web' ? TerminalType.PC : TerminalType.MOBILE;
      model.ActualParameters = form.actualParameters.map(p => {
        const a = new ActualParameter();
        a.Name = p.code;
        a.Tag = p.valueType ? p.valueType : this.initVariableType(p.value);
        a.Value = p.value;
        return a;
      });
      this.submit.next(model);
    } else {
      this.message.info(this.localePipe.transform('component.executeForms.selectedRow'));
    }
  }

  clickCancel() {
    this.cancel.next();
  }

  // selectOtherFormFormat() {
  //   this.lookUp.showDialog();
  // }

  // dictPicking = (arg) => {
  //   return of({
  //     showDialog: true, data: {
  //       tab: this.tab
  //     }
  //   });
  // }

  // dictPicked = (data: any): Observable<PickedResult> => {
  //   const model = new ExecuteFormModel();
  //   model.Id = ProcessDeUtil.GenerateElementId();
  //   model.Name = data.name;
  //   model.ComponentId = null;
  //   model.FormType = '0';
  //   model.formFormatId = data.id;
  //   model.TerminalType = this.tab === 'web' ? TerminalType.PC : TerminalType.MOBILE;
  //   model.ActualParameters = data.urlParameters.map(p => {
  //     const a = new ActualParameter();
  //     a.Name = p.code;
  //     a.Value = p.value;
  //     return a;
  //   });
  //   this.submit.next(model);
  //   return of({ closeDialog: true });
  // }

  // selectOtherFunc() {
  //   this.appHelper.showHelp(this.session.getUserSessionId());
  // }

  // funcSelected(apps: RtfApp[]) {
  //   if (apps && apps.length > 0) {
  //     const model = new ExecuteFormModel();
  //     model.Id = ProcessDeUtil.GenerateElementId();
  //     model.Name = apps[0].Name;
  //     model.ComponentId = apps[0].Id;
  //     model.FormType = '0';
  //     model.formFormatId = null;
  //     model.TerminalType = this.tab === 'web' ? TerminalType.PC : TerminalType.MOBILE;
  //     model.ActualParameters = [];
  //     if (apps[0].InvokingConfig['entityParams']) {
  //       const paras = JSON.parse(apps[0].InvokingConfig['entityParams']);
  //       model.ActualParameters = paras.map(p => ({
  //         Name: p.name,
  //         Value: ''
  //       }));
  //     }
  //     setTimeout(() => {
  //       this.submit.next(model);
  //     }, 0);
  //   }
  // }

  private getAllExecuteForms() {
    forkJoin(this.getExecuteForms(), this.getFormFormats()).subscribe(re => {
      if (re[0]) {
        this.forms = re[0];
      }
      if (re[1] && re[1].length > 0) {
        const formFormats = re[1];
        for (const format of formFormats) {
          if (this.forms.findIndex(f => f.formFormatId && f.formFormatId === format.id) === -1) {
            const executeForm = new ExecuteForm();
            executeForm.id = ProcessDeUtil.createNM();
            executeForm.flowFormKey = this.state.flowFormInfo.flowForm.id;
            executeForm.appId = null;
            executeForm.code = format.code;
            executeForm.name = format.name;
            executeForm.actualParameters = [];
            executeForm.isDefault = false;
            executeForm.formType = '0';
            executeForm.terminal = 'web';
            executeForm.formFormatId = format.id;
            executeForm.sysInit = 0;
            executeForm.remarks = '';
            if (format.urlParameters && format.urlParameters.length > 0) {
              const actPList = format.urlParameters.map(p => ({
                code: p.code,
                name: p.name,
                valueType: p.valueType ? p.valueType : this.initVariableType(p.value),
                value: p.value
              }));
              executeForm.actualParameters = actPList;
            }
            this.forms.push(executeForm);
          }
        }
      }
    });
  }

  initVariableType(value): string {
    if (value) {
        if (value.length >= 8 && value.slice(0, 8) === `{"expr":`) {
            return 'expression';
        } else {
            return 'constant';
        }
    } else {
        return 'variable';
    }
  }

  private getExecuteForms(): Observable<any> {
    if (this.state.flowFormInfo.flowForm.id && this.tab) {
      const url = `/api/runtime/wf/v1.0/excuteForm?flowFormKey=${this.state.flowFormInfo.flowForm.id}`;
      return this.http.get(url).pipe(
        map((re: any) => {
          if (this.tab === 'web') {
            return re.filter(f => f.terminal.indexOf('web') > -1);
          } else if (this.tab === 'mobile') {
            return re.filter(f => f.terminal.indexOf('app') > -1);
          }
        })
      );
    } else {
      return from(new Array());
    }
  }

  private getFormFormats(): Observable<any>  {
    if (this.state.flowFormInfo.flowForm.businessObjectId && this.tab) {
      const terminal = this.tab === 'web' ? 'PC' : 'Mobile';
      let url = `/api/runtime/wf/v1.0/formFormat/query?param=`;
      let param = `{"bizCategory":"${this.state.flowFormInfo.flowForm.businessObjectId}","terminal":"${terminal}"}`;
      param = encodeURIComponent(param);
      url += param;
      return this.http.get(url);
    } else {
      return from(new Array());
    }
  }

}
